import type { ReactNode } from 'react';
import { useShellTier } from '../../layouts/shellTier';
import { cx } from './primitives/cx';

export interface SummaryItem {
  label: string;
  value: ReactNode;
  /** Atenuado (p. ej. «Total anulado», que no cuenta). */
  muted?: boolean;
}

/**
 * P-075 · El resumen de una lista: UNA cifra principal y el resto en un desglose. Antes, cinco tarjetas
 * apiladas en el teléfono empujaban la lista fuera de la pantalla. Las cifras son las mismas y vienen
 * del mismo lugar: aquí solo cambia cuánto espacio ocupan.
 *
 * En el teléfono y la tableta el desglose va plegado (`<details>`, que el WebView 83 entiende); en
 * escritorio se ve en línea, donde sobra ancho.
 */
export function SummaryStrip({ label, primary, details = [], detailsLabel = 'Ver desglose', className }: {
  label: string;
  primary: SummaryItem;
  details?: SummaryItem[];
  detailsLabel?: string;
  className?: string;
}) {
  const tier = useShellTier();
  const list = details.length > 0 && (
    <dl className="n3-summary__list">
      {details.map((item) => (
        <div className={cx('n3-summary__item', item.muted && 'n3-summary__item--muted')} key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
  return (
    <section aria-label={label} className={cx('n3-summary', className)}>
      <div className="n3-summary__main">
        <span className="n3-summary__label">{primary.label}</span>
        <strong className="n3-summary__value">{primary.value}</strong>
      </div>
      {list && (tier === 'wide' ? list : (
        <details className="n3-summary__details">
          <summary className="n3-summary__toggle">{detailsLabel}</summary>
          {list}
        </details>
      ))}
    </section>
  );
}
